//import { ResourceCategories } from './resourcecategories';
export class ResourceOrganization {
    id: number;
    //text: string;
    name: string;    
    description__C: string;
    organization_Name__C: string;   
    category_Listing__C: string;
    website__C: string;
}